import { CommonService } from './CommonService';

export class SubscriptionService extends CommonService {

    entity;

    constructor(name_entity) {
        super(`${name_entity}`);
        this.entity = name_entity;
    }
    buySubscription = (body) => this.request('post', `create-payment-link`, '', body);

    // The two self-serve upgrade endpoints (server/src/routes/subscriptionRouter.js,
    // PR #95 and PR #123). This is the first piece of the Subscription page (PR 3a):
    // the page itself is not here yet, only the calls it will make.
    //
    // upgradePreview asks the server what moving to targetPlanId would cost today. It is
    // a POST even though it only asks a question, because the server resolves the price
    // against the live Stripe row and refuses anything that is not an upgrade.
    //
    // commitUpgrade charges the prorated difference and raises the limits. It sends back
    // the previewAmountCents the studio was shown, so the server can refuse to charge a
    // different number from the one on the confirm screen.
    //
    // Both refuse to send at all without a targetPlanId. A request with no plan would
    // only come back as a 400, and the page should never be able to make one by accident.
    upgradePreview = (targetPlanId) => {
        if (!targetPlanId) {
            return Promise.reject(new Error('upgradePreview needs a targetPlanId'));
        }
        return this.request('post', 'upgrade-preview', '', { targetPlanId });
    };

    commitUpgrade = (targetPlanId, previewAmountCents) => {
        if (!targetPlanId) {
            return Promise.reject(new Error('commitUpgrade needs a targetPlanId'));
        }
        if (!Number.isInteger(previewAmountCents)) {
            return Promise.reject(new Error('commitUpgrade needs previewAmountCents as a whole number of cents'));
        }
        return this.request('post', 'upgrade', '', { targetPlanId, previewAmountCents });
    };
}
